import React from "react";
import { FieldType } from "../../../services/helpers/types";
import { useTranslation } from "react-i18next";

interface MoreInfoFieldProps {
  field: FieldType;
  value?: string;
  onChange: (value: string) => void;
}

const MoreInfoField = (props: MoreInfoFieldProps) => {
  const { value, onChange } = props;

  const { t } = useTranslation();

  const handleTextAreaChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    const value = event.target.value;
    onChange(value);
  };
  return (
    <textarea
      onChange={handleTextAreaChange}
      value={value}
      className="dui-field-textArea-inner"
      placeholder={t("moreInfoPlaceholder")}
    ></textarea>
  );
};

export default MoreInfoField;
